/**
 * Init statistics disciplines widget
 */
const initStatisticsDisciplines = () => {
  const element = document.querySelector('[data-statistics-disciplines-widget]');
  if (!element) return;

  const type = element.getAttribute('data-type');

  let widgetOptions = {
    // apiHost: 'https://www.gpalabs.com',
    type,
  };

  widgetOptions = { ...widgetOptions };

  window.statisticsDisciplinesWidget(widgetOptions);
};

export default initStatisticsDisciplines;
